var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolsCalculators(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8182 2H6.18182C4.97683 2 4 2.99492 4 4.22222V19.7778C4 21.0051 4.97683 22 6.18182 22H17.8182C19.0232 22 20 21.0051 20 19.7778V4.22222C20 2.99492 19.0232 2 17.8182 2Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.07123H7.5C7.22386 5.07123 7 5.20554 7 5.37123V6.77123C7 6.93691 7.22386 7.07123 7.5 7.07123H16.5C16.7761 7.07123 17 6.93691 17 6.77123V5.37123C17 5.20554 16.7761 5.07123 16.5 5.07123Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0339 9.07123H7.17768C6.92139 9.07123 6.71362 9.29076 6.71362 9.56157V11.5229C6.71362 11.7937 6.92139 12.0133 7.17768 12.0133H9.0339C9.29019 12.0133 9.49795 11.7937 9.49795 11.5229V9.56157C9.49795 9.29076 9.29019 9.07123 9.0339 9.07123Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7458 9.07123H10.8896C10.6333 9.07123 10.4255 9.29076 10.4255 9.56157V11.5229C10.4255 11.7937 10.6333 12.0133 10.8896 12.0133H12.7458C13.0021 12.0133 13.2099 11.7937 13.2099 11.5229V9.56157C13.2099 9.29076 13.0021 9.07123 12.7458 9.07123Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4592 9.07123H14.603C14.3467 9.07123 14.1389 9.29076 14.1389 9.56157V11.5229C14.1389 11.7937 14.3467 12.0133 14.603 12.0133H16.4592C16.7155 12.0133 16.9232 11.7937 16.9232 11.5229V9.56157C16.9232 9.29076 16.7155 9.07123 16.4592 9.07123Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0339 12.9941H7.17768C6.92139 12.9941 6.71362 13.2137 6.71362 13.4845V15.4458C6.71362 15.7167 6.92139 15.9362 7.17768 15.9362H9.0339C9.29019 15.9362 9.49795 15.7167 9.49795 15.4458V13.4845C9.49795 13.2137 9.29019 12.9941 9.0339 12.9941Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7458 12.9941H10.8896C10.6333 12.9941 10.4255 13.2137 10.4255 13.4845V15.4458C10.4255 15.7167 10.6333 15.9362 10.8896 15.9362H12.7458C13.0021 15.9362 13.2099 15.7167 13.2099 15.4458V13.4845C13.2099 13.2137 13.0021 12.9941 12.7458 12.9941Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4592 12.9941H14.603C14.3467 12.9941 14.1389 13.2137 14.1389 13.4845V15.4458C14.1389 15.7167 14.3467 15.9362 14.603 15.9362H16.4592C16.7155 15.9362 16.9232 15.7167 16.9232 15.4458V13.4845C16.9232 13.2137 16.7155 12.9941 16.4592 12.9941Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0339 16.917H7.17768C6.92139 16.917 6.71362 17.1365 6.71362 17.4073V19.3687C6.71362 19.6395 6.92139 19.859 7.17768 19.859H9.0339C9.29019 19.859 9.49795 19.6395 9.49795 19.3687V17.4073C9.49795 17.1365 9.29019 16.917 9.0339 16.917Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7458 16.917H10.8896C10.6333 16.917 10.4255 17.1365 10.4255 17.4073V19.3687C10.4255 19.6395 10.6333 19.859 10.8896 19.859H12.7458C13.0021 19.859 13.2099 19.6395 13.2099 19.3687V17.4073C13.2099 17.1365 13.0021 16.917 12.7458 16.917Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4592 16.917H14.603C14.3467 16.917 14.1389 17.1365 14.1389 17.4073V19.3687C14.1389 19.6395 14.3467 19.859 14.603 19.859H16.4592C16.7155 19.859 16.9232 19.6395 16.9232 19.3687V17.4073C16.9232 17.1365 16.7155 16.917 16.4592 16.917Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsCalculators);
export default __webpack_public_path__ + "static/media/ToolsCalculators.1d65126dab7ae43648ee01afdf474c2b.svg";
export { ForwardRef as ReactComponent };